import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { InternalPage } from 'theSource/components';
import { useConfigurationQuery } from 'theSource/queries';
import { queryKeyGenerator } from 'theSource/utils';
import { useBenefitCategoryQuery } from 'enrollment/queries';
import { BenefitDto } from 'enrollment/queries/useBenefitCategoryQuery/types';
import {
  selectEnrollmentContext,
  selectEnrollmentOrgPlanYearId,
} from 'theSource/features/Home/components/EnrollmentBanner/services';
import { PsButtonTuner } from 'stencilSetup';
import { ROUTES } from 'enrollment/app/routes';
import { IndividualPlanInfoItem } from './components/IndividualPlanInfoItem';

interface LocationState {
  fromSavviPage?: boolean;
}

export const AdditionalPlanInfoReview = () => {
  const { t } = useTranslation('enrollment.additionalPlanInfo');
  const navigate = useNavigate();
  const location = useLocation() as { state?: LocationState };
  const fromSavviPage = location.state?.fromSavviPage || false;

  const { configuration } = useConfigurationQuery();
  const lumosApiHost = configuration?.apiHost;

  const enrollmentContext = useSelector(selectEnrollmentContext);
  let orgPlanYearContextId = useSelector(selectEnrollmentOrgPlanYearId);
  orgPlanYearContextId =
    enrollmentContext === 'life_event' ? orgPlanYearContextId : 0;
  const key = fromSavviPage ? 'benefits' : 'benefits-details';

  const { data: benefitData } = useBenefitCategoryQuery({
    key: queryKeyGenerator(
      `${key}-${enrollmentContext}`,
      Number(orgPlanYearContextId)
    ),
    enrollmentContextType: enrollmentContext,
    enabled: true,
    lumosApiHost: String(lumosApiHost),
    includeEligibleDependentsData: true,
    orgPlanYearId: orgPlanYearContextId,
  });

  const AdditionalPlanInfo = benefitData?.data?.benefits?.filter(
    (benefit: BenefitDto) =>
      benefit.coverage && benefit.coverage.has_popup_content
  );

  const plansLength = AdditionalPlanInfo?.length || 0;

  const handleContinue = () => {
    if (fromSavviPage) {
      navigate(`/enrollment${ROUTES.enrollment.benefits.path}`);
    } else {
      navigate(`/enrollment${ROUTES.enrollment.benefitDetails.path}`);
    }
  };

  return (
    <InternalPage
      testId="additional-plan-information-page"
      title={t('title')}
      description={t('subtitle')}
      customActionAlignment="left"
      withBackLink={!fromSavviPage}
      backLinkPath={`/enrollment/${ROUTES.enrollment.benefitDetails.path}`}
    >
      <div id="plan-information" className="card">
        <h2 className="mb-4">{t('cardTitle')}</h2>
        {AdditionalPlanInfo &&
          lumosApiHost &&
          AdditionalPlanInfo.map(
            (Benefitcoverage: BenefitDto, index) =>
              Benefitcoverage.coverage && (
                <IndividualPlanInfoItem
                  orgBenefitId={Benefitcoverage.benefit.org_benefit_id}
                  coverage={Benefitcoverage.coverage}
                  lumosApiHost={lumosApiHost}
                  lastPlan={index === plansLength - 1}
                />
              )
          )}
      </div>
      <PsButtonTuner
        data-testid="looks-good-continue"
        buttonId="looks-good-continue"
        label={t('looksGood')}
        level="primary"
        onClick={handleContinue}
      />
    </InternalPage>
  );
};
